import React, { Component } from "react";

class Home extends Component {
  render() {
    return (
      <div>
        <h1>We're working on Plant Parent for you.</h1>
        <h3>Come back on July 23, 2020 to see our launch!</h3>
        <br />
        <h4>
          Check out our page <i>Explore Plants</i> in the meantime for a
          preview.
        </h4>
      </div>
    );
  }
}

export default Home;
